import { ManualAccountsAssetAllocationTaxStatusIdDTO } from '../../ManualAccountsAssetAllocation/types';
import { AccountType } from './api/useAccountsOptionsQuery';
import { AccountDTO, TaxStatusDTO } from './api/useAccountsQuery';
import { AssetAllocationDTO } from './api/useDefaultAssetAllocationQuery';

export function getDefaultAssetAllocation(
  defaultAllocations: Record<ManualAccountsAssetAllocationTaxStatusIdDTO, AssetAllocationDTO[]>,
  account: Pick<AccountDTO, 'AccountType' | 'TaxStatus' | 'AnnuityIsAnnuitized'>,
): AssetAllocationDTO[] {
  const { AccountType: accountType, TaxStatus: taxStatus, AnnuityIsAnnuitized: annuityIsAnnuitized } = account;

  switch (accountType) {
    case AccountType.E401K:
      switch (taxStatus) {
        case TaxStatusDTO.PreTax:
          return defaultAllocations[ManualAccountsAssetAllocationTaxStatusIdDTO.TaxDeferred];
        case TaxStatusDTO.Roth:
          return defaultAllocations[ManualAccountsAssetAllocationTaxStatusIdDTO.TaxFree];
        case TaxStatusDTO.AfterTax:
          return defaultAllocations[ManualAccountsAssetAllocationTaxStatusIdDTO.Other];
      }
    case AccountType.E403B:
      switch (taxStatus) {
        case TaxStatusDTO.PreTax:
          return defaultAllocations[ManualAccountsAssetAllocationTaxStatusIdDTO.TaxDeferred];
        case TaxStatusDTO.Roth:
          return defaultAllocations[ManualAccountsAssetAllocationTaxStatusIdDTO.TaxFree];
        case TaxStatusDTO.AfterTax:
          return defaultAllocations[ManualAccountsAssetAllocationTaxStatusIdDTO.Other];
      }
    case AccountType.SepIra:
      switch (taxStatus) {
        case TaxStatusDTO.PreTax:
          return defaultAllocations[ManualAccountsAssetAllocationTaxStatusIdDTO.TaxDeferred];
        case TaxStatusDTO.Roth:
          return defaultAllocations[ManualAccountsAssetAllocationTaxStatusIdDTO.TaxFree];
      }
    case AccountType.SimpleIra:
      switch (taxStatus) {
        case TaxStatusDTO.PreTax:
          return defaultAllocations[ManualAccountsAssetAllocationTaxStatusIdDTO.TaxDeferred];
        case TaxStatusDTO.Roth:
          return defaultAllocations[ManualAccountsAssetAllocationTaxStatusIdDTO.TaxFree];
      }

    case AccountType.Annuity:
      if (annuityIsAnnuitized) {
        return defaultAllocations[ManualAccountsAssetAllocationTaxStatusIdDTO.Other];
      }
      return defaultAllocations[ManualAccountsAssetAllocationTaxStatusIdDTO.TaxDeferred];

    case AccountType.IRA:
    case AccountType.InheritedIra:
    case AccountType.EmployerPlan:
    case AccountType.E401A:
    case AccountType.E457:
    case AccountType.TaxDeferred:
      return defaultAllocations[ManualAccountsAssetAllocationTaxStatusIdDTO.TaxDeferred];

    case AccountType.Roth:
    case AccountType.InheritedRoth:
    case AccountType.TaxFree:
    case AccountType.Roth401K:
    case AccountType.DonorAdvisedFund:
      return defaultAllocations[ManualAccountsAssetAllocationTaxStatusIdDTO.TaxFree];

    case AccountType.HSA:
    case AccountType.DonorAdvisedFund:
    case AccountType.E529:
      return defaultAllocations[ManualAccountsAssetAllocationTaxStatusIdDTO.Other];

    default:
      return defaultAllocations[ManualAccountsAssetAllocationTaxStatusIdDTO.TaxableInvestment];
  }
}
